/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdataroom_Emptytitle4Inputs */

const en_coinvestments_lpdataroom_emptytitle4 = /** @type {(inputs: Coinvestments_Lpdataroom_Emptytitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No documents`)
};

/**
* | output |
* | --- |
* | "No documents" |
*
* @param {Coinvestments_Lpdataroom_Emptytitle4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdataroom_emptytitle4 = /** @type {((inputs?: Coinvestments_Lpdataroom_Emptytitle4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdataroom_Emptytitle4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdataroom_emptytitle4(inputs)
});
export { coinvestments_lpdataroom_emptytitle4 as "coInvestments_lpDataRoom_emptyTitle" }